import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { useAppDispatch } from '@libs/redux/hooks'
import { authSlice } from '@libs/redux/auth/auth.slice'
import { AuthCookieService } from '@utils/AuthCookieService'
import { apolloClient } from '@libs/apollo/client'

import { useAppState } from '@hooks/app/app-state.hook'

export const useSignOut = (): {
  signOut: () => Promise<void>
} => {
  const dispatch = useAppDispatch()

  const location = useLocation()
  const navigate = useNavigate()
  const { i18n } = useTranslation()

  const { clearAppSate } = useAppState()

  const signOut = async () => {
    AuthCookieService.clearAuthInfo()

    apolloClient.clearStore()

    dispatch(authSlice.actions.signOut())

    clearAppSate()

    const signInPath = `/${i18n.language}/sign-in`
    navigate(signInPath, { state: { from: location } })
  }

  return { signOut }
}
